import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface AssetCategories {
  category_type_id: string
  category_type_name: string
}

export interface AssetCategoriesState {
  isLoading: boolean
  loadingError: string | null
  assetCategories: AssetCategories[] | null
  httpStatus: number | null
}

export const initialState: AssetCategoriesState = {
  isLoading: true,
  loadingError: null,
  assetCategories: null,
  httpStatus: null
}

export const assetCategoriesSlice = createSlice({
  name: 'deviceManagementAssetCategories',
  initialState,
  reducers: {
    assetCategoriesLoadingAction: (state) => {
      return {
        isLoading: true,
        loadingError: null,
        assetCategories: null,
        httpStatus: 0
      }
    },
    assetCategoriesUpdateAction: (state, action: PayloadAction<{ data: AssetCategories[], httpStatus: number }>) => {
      return {
        isLoading: false,
        loadingError: null,
        assetCategories: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    assetCategoriesErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>) => {
      return {
        isLoading: false,
        loadingError: action.payload.errorMessage,
        assetCategories: null,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

export const {
  assetCategoriesLoadingAction,
  assetCategoriesUpdateAction,
  assetCategoriesErrorAction
} = assetCategoriesSlice.actions

export default assetCategoriesSlice.reducer
